// Versionszeile der Upload-Summary: „Existing versions: v1, v2 · v3 incomplete“.
// Halbe (pending) Versionen werden eigens genannt, damit das Talent sieht,
// dass dort etwas fehlt (Audit 2026-09-24, M15).

export function formatVersionsHint(
  complete: ReadonlyArray<{ version: number }>,
  pending: ReadonlyArray<{ version: number }>,
): string | null {
  const parts: string[] = [];
  if (complete.length > 0) parts.push(`Existing versions: ${complete.map((v) => `v${v.version}`).join(', ')}`);
  if (pending.length > 0) parts.push(`${pending.map((v) => `v${v.version}`).join(', ')} incomplete`);
  return parts.length > 0 ? parts.join(' · ') : null;
}
